import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "caass-ms-demographic-visitee-table",
	templateUrl: "./ms-demographic-visitee-table.component.html",
	styleUrls: ["./ms-demographic-visitee-table.component.css"],
})
export class MsDemographicVisiteeTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	pagerows: any = 5;
	pagefirst: any = 0;

	SelectedVisitee: any;

	@Input() lstVisitee: any = [];
	@Input() loading: boolean = false;

	lstFacilityName: any = [];

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "VisiteeName", header: "Name" },
		{ field: "VisitCount", header: "Count" },
		{ field: "Email", header: "Email" },
	];

	////////////////////////////////////////////
}
